import Title from "../components/TheTitle.vue";
import { getBrandsMaster, getStoresMaster, searchPointBulkGrantHistory, } from "../api";
import { Validation } from "../utils/validation";
import { FormatDate } from "../utils/formatDate";
import { Authorize } from "../utils/authorize";
export default {
    name: "pointBulkGrantHistory",
    data() {
        return {
            brandInfo: [],
            storeInfo: [],
            infoPage: 1,
            pageSize: 100,
            tableInfo: [],
            form: {
                operationDateFrom: "",
                operationDateTo: "",
                effectivePeriodDateFrom: "",
                effectivePeriodDateTo: "",
                brandId: "",
                storeId: "",
                publisher: "",
                pointName: "",
                pointsMin: "",
                pointsMax: "",
            },
        };
    },
    components: {
        Title,
    },
    computed: {
        infoTotalPages() {
            return Math.max(1, Math.ceil(this.tableInfo.length / this.pageSize));
        },
        pagedInfo() {
            const start = (this.infoPage - 1) * this.pageSize;
            return this.tableInfo.slice(start, start + this.pageSize);
        },
    },
    watch: {
        "form.brandId": async function (newBrand) {
            if (!newBrand) {
                this.storeInfo = [];
                this.form.storeId = "";
                return;
            }
            try {
                const response = await getStoresMaster(newBrand); // brandId を直接渡す
                if (response.result?.code === 9) {
                    this.$store.commit("setMessages", response.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                else {
                    this.storeInfo = response.data.results || [];
                    // 選択中の store が新しい storeInfo に存在しない場合はクリアする
                    if (!this.storeInfo.find((s) => s.storeId === this.form.storeId)) {
                        this.form.store = "";
                    }
                }
            }
            catch (err) {
                //
            }
        },
    },
    methods: {
        setInfoPage(p) {
            if (p < 1)
                p = 1;
            if (p > this.infoTotalPages)
                p = this.infoTotalPages;
            this.infoPage = p;
        },
        formatDatetime(value) {
            return FormatDate.withoutTzAndMs(value);
        },
        exportCsv() {
            if (!this.tableInfo.length) {
                this.$store.commit("setMessages", ["出力対象のデータが存在しません。"]);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            // 1) ヘッダを作成
            const header = [
                "一括付与ID",
                "ブランド",
                "付与店舗",
                "ポイント名",
                "付与ポイント数",
                "有効期限",
                "担当者",
                "操作日時",
            ];
            // 2) tableInfo から値を取得（空文字や null は空文字に）
            const rows = this.tableInfo.map((t) => [
                t.point_bulk_grant_history_id,
                t.brand,
                t.store,
                t.point_name,
                t.points,
                t.effective_period_date,
                t.publisher,
                this.formatDatetime(t.operation_date),
            ]);
            // 3) CSV を作る
            const escapeCsv = (value) => {
                if (value == null)
                    return "";
                const v = String(value);
                return v;
            };
            const lines = [];
            lines.push(header.map(escapeCsv).join(","));
            for (const r of rows) {
                lines.push(r.map(escapeCsv).join(","));
            }
            let csvContent = lines.join("\r\n");
            // 4) Excel で文字化けしにくくするために UTF-8 BOM を付与（不要なら削除）
            const bom = "\uFEFF";
            const blob = new Blob([bom + csvContent], {
                type: "text/csv;charset=utf-8;",
            });
            // 5) ダウンロード処理
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            // ファイル名（任意）
            a.download = "ポイント一括付与履歴検索_検索結果.csv";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },
        goToResult(id) {
            this.$router.push(`/pointGrantResult/${id}`);
        },
        onClear() {
            this.form = {
                operationDateFrom: "",
                operationDateTo: "",
                effectivePeriodDateFrom: "",
                effectivePeriodDateTo: "",
                brandId: "",
                storeId: "",
                publisher: "",
                pointName: "",
                pointsMin: "",
                pointsMax: "",
            };
        },
        async onSearch() {
            const params = {
                operation_date_from: (this.form.operationDateFrom || null),
                operation_date_to: (this.form.operationDateTo || null),
                effective_period_date_from: (this.form.effectivePeriodDateFrom ||
                    null),
                effective_period_date_to: (this.form.effectivePeriodDateTo ||
                    null),
                brand_id: (this.form.brandId || null),
                store_id: (this.form.storeId || null),
                publisher: (this.form.publisher || null),
                point_name: (this.form.pointName || null),
                points_min: (this.form.pointsMin || null),
                points_max: (this.form.pointsMax || null),
            };
            const errorMessage = this.validate(params);
            if (errorMessage) {
                this.$store.commit("setMessages", errorMessage);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            const response = await searchPointBulkGrantHistory("", params.operation_date_from, params.operation_date_to, params.effective_period_date_from, params.effective_period_date_to, params.brand_id, params.store_id, params.publisher, params.point_name, params.points_min, params.points_max);
            if (response.result?.code === 9) {
                this.$store.commit("setMessages", response.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
            }
            else {
                this.tableInfo = response.data.results;
                this.infoPage = 1;
            }
        },
        validate(params) {
            // エラーメッセージを格納する配列
            const errors = [];
            // 桁数チェック
            errors.push(...Validation.digitsMax({
                key: "ポイント名",
                value: params.point_name,
            }, 100));
            errors.push(...Validation.digitsMax({
                key: "付与ポイント数上限",
                value: params.points_max,
            }, 6));
            errors.push(...Validation.digitsMax({
                key: "付与ポイント数下限",
                value: params.points_min,
            }, 6));
            errors.push(...Validation.digitsMax({
                key: "有効期限上限",
                value: params.effective_period_date_from,
            }, 4));
            errors.push(...Validation.digitsMax({
                key: "有効期限下限",
                value: params.effective_period_date_to,
            }, 4));
            errors.push(...Validation.digitsMax({
                key: "担当者",
                value: params.publisher,
            }, 100));
            // 属性チェック
            if (params.points_max) {
                errors.push(...Validation.isInteger({
                    key: "付与ポイント数上限",
                    value: params.points_max,
                }));
            }
            if (params.points_min) {
                errors.push(...Validation.isInteger({
                    key: "付与ポイント数下限",
                    value: params.points_min,
                }));
            }
            if (params.effective_period_date_from) {
                errors.push(...Validation.isInteger({
                    key: "有効期限下限",
                    value: params.effective_period_date_from,
                }));
            }
            if (params.effective_period_date_to) {
                errors.push(...Validation.isInteger({
                    key: "有効期限上限",
                    value: params.effective_period_date_to,
                }));
            }
            // 相関チェック
            if (params.points_max &&
                params.points_min &&
                Number(params.points_min) >= Number(params.points_max)) {
                errors.push("付与ポイント数の下限値と上限値は、下限値が上限値より小さくなるように入力してください。");
            }
            if (params.effective_period_date_from &&
                params.effective_period_date_to &&
                Number(params.effective_period_date_from) >=
                    Number(params.effective_period_date_to)) {
                errors.push("有効期間の下限値と上限値は、下限値が上限値より小さくなるように入力してください。");
            }
            if (params.operation_date_from &&
                params.operation_date_to &&
                params.operation_date_from > params.operation_date_to) {
                errors.push("操作日時のFromとToは、FromがToより小さくなるように入力してください。");
            }
            if (errors.length > 0) {
                return errors;
            }
            return "";
        },
    },
    async mounted() {
        if (await Authorize.isExpired(this)) {
            const response = await getBrandsMaster("OPS");
            if (response.result?.code === 9) {
                this.$store.commit("setMessages", response.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
            }
            else {
                this.brandInfo = response.data.results;
            }
        }
    },
};
